import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export interface SwitchWithLabelProps {
    label: string;
    onChange?: (checked: boolean) => void;
    checked?: boolean;
}

export default function SwitchWithLabel({ label, onChange, checked }: SwitchWithLabelProps) {
    return (
        <div className="flex items-center gap-2 w-full justify-between">
            <Label htmlFor="airplane-mode">{label}</Label>
            <Switch id="airplane-mode" onCheckedChange={onChange} checked={checked} />
        </div>
    );
}
